"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reusableFields = require("egov-ui-kit/config/forms/specs/PropertyTaxPay/utils/reusableFields");

var _actions = require("egov-ui-kit/redux/app/actions");

var _actions2 = require("egov-ui-kit/redux/common/actions");

var _actions3 = require("egov-ui-kit/redux/form/actions");

var _commons = require("egov-ui-kit/utils/commons");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _filter = require("lodash/filter");

var _filter2 = _interopRequireDefault(_filter);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _sortBy = require("lodash/sortBy");

var _sortBy2 = _interopRequireDefault(_sortBy);

var _actions4 = require("../../../../../../../packages/lib/egov-ui-framework/ui-redux/screen-configuration/actions");

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _commons2 = require("egov-ui-framework/ui-utils/commons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "demandDetails",
  fields: {
    holdingTax: {
      id: "holding-tax",
      jsonPath: "Properties[0].additionalDetails.holdingTax",
      type: "textfield",
      floatingLabelText: "PT_HOLDING_TAX",
      hintText: "PT_HOLDING_TAX_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_HOLDING_TAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(additionalDetails)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    lightTax: {
      id: "ligth-tax",
      jsonPath: "Properties[0].additionalDetails.lightTax",
      type: "textfield",
      floatingLabelText: "PT_LIGHT_TAX",
      hintText: "PT_LIGHT_TAX_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_LIGHT_TAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = Object.entries(additionalDetails)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                key = _step2$value[0],
                value = _step2$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    waterTax: {
      id: "water-tax",
      jsonPath: "Properties[0].additionalDetails.waterTax",
      type: "textfield",
      floatingLabelText: "PT_WATER_TAX",
      hintText: "PT_WATER_TAX_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_WATER_TAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      required: true,
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = Object.entries(additionalDetails)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
                key = _step3$value[0],
                value = _step3$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    drainageTax: {
      id: "drainage-tax",
      jsonPath: "Properties[0].additionalDetails.drainageTax",
      type: "textfield",
      floatingLabelText: "PT_DRAINAGE_TAX",
      hintText: "PT_DRAINAGE_TAX_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_DRAINAGE_TAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = Object.entries(additionalDetails)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
                key = _step4$value[0],
                value = _step4$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    latrineTax: {
      id: "latrine-tax",
      jsonPath: "Properties[0].additionalDetails.latrineTax",
      type: "textfield",
      floatingLabelText: "PT_LATRINE_TAX",
      hintText: "PT_LATRINE_TAX_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_LATRINE_TAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = Object.entries(additionalDetails)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _step5$value = (0, _slicedToArray3.default)(_step5.value, 2),
                key = _step5$value[0],
                value = _step5$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    parkingTax: {
      id: "parking-tax",
      jsonPath: "Properties[0].additionalDetails.parkingTax",
      type: "textfield",
      floatingLabelText: "PT_PARKING_TAX",
      hintText: "PT_PARKING_TAX_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_PARKING_TAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = Object.entries(additionalDetails)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _step6$value = (0, _slicedToArray3.default)(_step6.value, 2),
                key = _step6$value[0],
                value = _step6$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    solidWasteUserCharges: {
      id: "solidwaste-charges",
      jsonPath: "Properties[0].additionalDetails.solidWasteUserCharges",
      type: "textfield",
      floatingLabelText: "PT_SOLID_WASTER_USER_CHARGES",
      hintText: "PT_SOLID_WASTER_USER_CHARGES_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_SOLID_WASTER_USER_CHARGES_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = Object.entries(additionalDetails)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _step7$value = (0, _slicedToArray3.default)(_step7.value, 2),
                key = _step7$value[0],
                value = _step7$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    ownershipExemption: {
      id: "ownership-exemption",
      jsonPath: "Properties[0].additionalDetails.ownershipExemption",
      type: "textfield",
      floatingLabelText: "PT_OWNERSHIP_EXEMPTION",
      hintText: "PT_OWNERSHIP_EXEMPTION_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_OWNERSHIP_EXEMPTION_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = Object.entries(additionalDetails)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var _step8$value = (0, _slicedToArray3.default)(_step8.value, 2),
                key = _step8$value[0],
                value = _step8$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    usageExemption: {
      id: "usage-exemption",
      jsonPath: "Properties[0].additionalDetails.usageExemption",
      type: "textfield",
      floatingLabelText: "PT_USAGE_EXEMPTION",
      hintText: "PT_USAGE_EXEMPTION_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_USAGE_EXEMPTION_ERRORMSG",
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = Object.entries(additionalDetails)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var _step9$value = (0, _slicedToArray3.default)(_step9.value, 2),
                key = _step9$value[0],
                value = _step9$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    interest: {
      id: "interest",
      jsonPath: "Properties[0].additionalDetails.interest",
      type: "textfield",
      floatingLabelText: "PT_INTEREST",
      hintText: "PT_INTEREST_PLACEHOLDER",
      numcols: 6,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      errorMessage: "PT_INTEREST_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      required: true,
      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = Object.entries(additionalDetails)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var _step10$value = (0, _slicedToArray3.default)(_step10.value, 2),
                key = _step10$value[0],
                value = _step10$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)));
      }
    },
    penalty: {
      id: "penalty",
      jsonPath: "Properties[0].additionalDetails.penalty",
      type: "textfield",
      floatingLabelText: "PT_PENALTY",
      hintText: "PT_PENALTY_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_PENALTY_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      required: true,
      updateDependentFields: function updateDependentFields(_ref11) {
        var formKey = _ref11.formKey,
            field = _ref11.field,
            dispatch = _ref11.dispatch,
            state = _ref11.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = Object.entries(additionalDetails)[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _step11$value = (0, _slicedToArray3.default)(_step11.value, 2),
                key = _step11$value[0],
                value = _step11$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)), 0);
      }
    },
    serviceTax: {
      id: "serviceTax",
      jsonPath: "Properties[0].additionalDetails.serviceTax",
      type: "textfield",
      floatingLabelText: "PT_PROPERTY_SERVICETAX",
      hintText: "PT_PROPERTY_SERVICETAX_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_PROPERTY_SERVICETAX_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      required: true,
      updateDependentFields: function updateDependentFields(_ref12) {
        var formKey = _ref12.formKey,
            field = _ref12.field,
            dispatch = _ref12.dispatch,
            state = _ref12.state;

        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = Object.entries(additionalDetails)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var _step12$value = (0, _slicedToArray3.default)(_step12.value, 2),
                key = _step12$value[0],
                value = _step12$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)), 0);
      }
    },
    otherDues: {
      id: "otherDues",
      jsonPath: "Properties[0].additionalDetails.otherDues",
      type: "textfield",
      floatingLabelText: "PT_PROPERTY_OTHERDUES",
      hintText: "PT_PROPERTY_OTHERDUES_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_PROPERTY_OTHERDUES_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      pattern: /^([0-9][0-9]{0,49})(\.\d{1,2})?$/,
      required: true,
      updateDependentFields: function updateDependentFields(_ref13) {
        var formKey = _ref13.formKey,
            field = _ref13.field,
            dispatch = _ref13.dispatch,
            state = _ref13.state;

        if (field && field.value && field.value != " " && field.value != 0) {
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "pendingFrom", "disabled", false));
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "pendingFrom", "visible", true));
        } else {
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "pendingFrom", "disabled", true));
        }
        var additionalDetails = state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails || {};
        var amountArray = [];
        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
          for (var _iterator13 = Object.entries(additionalDetails)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var _step13$value = (0, _slicedToArray3.default)(_step13.value, 2),
                key = _step13$value[0],
                value = _step13$value[1];

            if (key == "usageExemption" || key == "ownershipExemption") {
              amountArray.push(Number(-value));
            } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
              amountArray.push(Number(value));
            }
          }
        } catch (err) {
          _didIteratorError13 = true;
          _iteratorError13 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion13 && _iterator13.return) {
              _iterator13.return();
            }
          } finally {
            if (_didIteratorError13) {
              throw _iteratorError13;
            }
          }
        }

        var total = amountArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)), 0);
      }
    },
    pendingFrom: {
      id: "pendingFrom",
      jsonPath: "Properties[0].additionalDetails.pendingFrom",
      type: "textfield",
      floatingLabelText: "PT_PROPERTY_PENDINGFROM",
      hintText: "PT_PROPERTY_PENDINGFROM_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_PROPERTY_PENDINGFROM_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      pattern: /^[^*|\":<>[\]{}`\\()';@&$#!]+$/,
      required: false,
      visible: false,
      disabled: true,
      updateDependentFields: function updateDependentFields(_ref14) {
        var formKey = _ref14.formKey,
            field = _ref14.field,
            dispatch = _ref14.dispatch,
            state = _ref14.state;
      }
    },
    totalAmount: {
      id: "totalAmount",
      jsonPath: "Properties[0].additionalDetails.totalAmount",
      type: "textfield",
      floatingLabelText: "PT_TOTAL_AMOUNT",
      hintText: "PT_TOTAL_AMOUNT_PLACEHOLDER",
      numcols: 6,
      errorMessage: "PT_TOTAL_AMOUNT_ERRORMSG",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      pattern: /^[1-9]\d*(?:\.\d+)?$/
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    try {
      var mode = (0, _commons2.getQueryArg)(window.location.href, "mode");
      if (mode == "editDemandDetails" || mode == "WORKFLOWEDIT") {
        var state = store.getState();
        var additionalDetails = mode == "editDemandDetails" ? state.screenConfiguration.preparedFinalObject.Properties && state.screenConfiguration.preparedFinalObject.Properties[0].additionalDetails : mode == "WORKFLOWEDIT" ? state.screenConfiguration.preparedFinalObject.newProperties && state.screenConfiguration.preparedFinalObject.newProperties[0].additionalDetails : {};
        if (additionalDetails && additionalDetails.hasOwnProperty('otherDues') && additionalDetails.otherDues && additionalDetails.otherDues != '' && additionalDetails.otherDues != 0) {
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "pendingFrom", "disabled", false));
        } else {
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "pendingFrom", "disabled", true));
        }
        if (additionalDetails && additionalDetails.hasOwnProperty('holdingTax')) {
          var amountArray = [];
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = Object.entries(additionalDetails)[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var _step14$value = (0, _slicedToArray3.default)(_step14.value, 2),
                  key = _step14$value[0],
                  value = _step14$value[1];

              if (key == "usageExemption" || key == "ownershipExemption") {
                amountArray.push(Number(-value));
              } else if (key !== "previousPropertyUuid" && key !== 'isRainwaterHarvesting' && key !== 'pendingFrom' && key !== 'reasonForTransfer' && key !== 'documentDate' && key !== 'documentNumber' && key !== 'documentValue' && key !== 'marketValue') {
                amountArray.push(Number(value));
              }
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }

          var total = amountArray.reduce(function (a, b) {
            return a + b;
          }, 0);
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "totalAmount", "value", total.toFixed(2)), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "holdingTax", "value", additionalDetails.holdingTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "lightTax", "value", additionalDetails.lightTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "waterTax", "value", additionalDetails.waterTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "drainageTax", "value", additionalDetails.drainageTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "latrineTax", "value", additionalDetails.latrineTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "parkingTax", "value", additionalDetails.parkingTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "solidWasteUserCharges", "value", additionalDetails.solidWasteUserCharges), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "ownershipExemption", "value", additionalDetails.ownershipExemption), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "usageExemption", "value", additionalDetails.usageExemption), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "interest", "value", additionalDetails.interest), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "penalty", "value", additionalDetails.penalty), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "serviceTax", "value", additionalDetails.serviceTax), "0");
          dispatch((0, _actions3.setFieldProperty)("demandDetails", "otherDues", "value", additionalDetails.otherDues), "0");
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/demandDetails.js
// module id = 1878
// module chunks = 1137